import $ from 'jquery';
import 'modernizr';

$(() => {
  // eslint-disable-next-line
  console.log('👍');
});
